import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowMidRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M28.15 10.279 26.028 12.4l10.101 10.1H8.25v3h27.879L26.028 35.6l2.122 2.121L41.872 24z" }) }) })
});
export default SvgArrowMidRight;
